import React from 'react';
import type { AutoSaveStatus } from '../../hooks/useAutoSave';
import './AutoSaveIndicator.css';

interface AutoSaveIndicatorProps {
  status: AutoSaveStatus;
  error: string | null;
}

const AutoSaveIndicator: React.FC<AutoSaveIndicatorProps> = ({ status, error }) => {
  switch (status) {
    case 'idle':
      return null;
    case 'pending':
      return (
        <span className="autosave-indicator autosave-pending">
          Modifications non enregistrées
        </span>
      );
    case 'saving':
      return (
        <span className="autosave-indicator autosave-saving">
          <span className="autosave-spinner" />
          Enregistrement…
        </span>
      );
    case 'saved':
      return (
        <span className="autosave-indicator autosave-saved">
          ✓ Enregistré
        </span>
      );
    case 'error':
      return (
        <span className="autosave-indicator autosave-error">
          ❌ Erreur — {error}
        </span>
      );
    default:
      return null;
  }
};

export default AutoSaveIndicator;
